/* Cards Quest — corrections mobile (Thème CQ 1.0.8)
   1) Chevrons garantis dans le menu burger.
   2) Email du footer = lien stylé sans soulignement.
   3) Fiche produit mobile : remonte la rareté au-dessus de l'image. */
(function () {
  function injectCarets() {
    var summaries = document.querySelectorAll('.menu-drawer__menu li > details > summary');
    summaries.forEach(function (sum) {
      var details = sum.parentElement;
      if (!details || !details.querySelector('.menu-drawer__submenu')) return;
      if (sum.querySelector('.cq-caret')) return;
      sum.querySelectorAll('.icon-arrow').forEach(function (e) { e.style.display = 'none'; });
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('class', 'cq-caret');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'width:2.2rem;height:2.2rem;min-width:2.2rem;flex:0 0 auto;margin-left:auto;color:rgb(109,109,109);pointer-events:none;';
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M5 7.5l5 5 5-5');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      sum.appendChild(svg);
      details.addEventListener('toggle', function () {
        svg.style.transform = details.open ? 'rotate(180deg)' : 'rotate(0deg)';
      });
    });
  }
  function fixFooterEmail() {
    document.querySelectorAll('.footer-block__contacts-text').forEach(function (p) {
      var existing = p.querySelector('a');
      if (existing) { existing.style.textDecoration = 'none'; existing.style.color = 'inherit'; return; }
      var m = p.textContent.match(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/);
      if (!m) return;
      var email = m[0];
      p.innerHTML = p.innerHTML.replace(email, '<a href="mailto:' + email + '" style="text-decoration:none;color:inherit;">' + email + '</a>');
    });
  }
  function moveRarityBadge() {
    if (window.innerWidth > 989) return;
    var outer = document.querySelector('.product__outer');
    if (!outer) return;
    var main = outer.querySelector(':scope > .product__main');
    var info = outer.querySelector(':scope > .product__info-container');
    if (!main || !info) return;
    var badge = info.querySelector('.badge-rarete');
    if (badge && badge.parentElement !== outer) {
      outer.insertBefore(badge, main);
    }
  }
  function run() {
    try { injectCarets(); } catch (e) {}
    try { fixFooterEmail(); } catch (e) {}
    try { moveRarityBadge(); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', function () { try { moveRarityBadge(); } catch (e) {} });
  window.addEventListener('load', function () { setTimeout(run, 300); });
})();
